<script>
export default {
    name: "ViewDocument",

    props: {

        showModal: Boolean,
        document: Object,
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">View Document</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap -m-4">
        <img :src="`data:application/image;base64,${document.document}`" alt="doc image" srcset="">
        <iframe 
            :src="`data:application/pdf;base64,${document.document}`" 
            height="700" width="2000"></iframe>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
      class="btn-danger btn-sm text-xs rounded" 
      @click="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Cancel</button>
  </template>
</tail-modal>
</template>